import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import Breadcrums from "../../common/breadcrumbs";
import {
    globalLoader,
    handleServerValidations,
} from "../../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../../utils/Constants";
import { Update, Details } from "../../services/pujaType.services";

const EditPujaType = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { t } = useTranslation();
    const [submitted, setSubmitted] = useState(false);
    const [initialData, setInitialData] = useState({
        title: "",
        status: 1,
    });
    useEffect(() => {
    if (id) {
        globalLoader(true);

        Details(id)
            .then((response) => {
                if (response.success) {
                    setInitialData({
                        title: response.data.title || "",
                        status: Number(response.data.status),
                    });
                } else {
                    Swal.fire({
                        icon: "error",
                        text: response.message,
                        ...SWAL_SETTINGS,
                    });
                }
                globalLoader(false);
            })
            .catch((error) => {
                console.log("error ====> ", error);
                globalLoader(false);
            });
    }
}, [id]);

    const breadcrumbs = [
        { title: t("link_dashboard"), url: "/admin/dashboard" },
        { title: "Puja Types", url: "/admin/puja-type/list/1" },
        { title: t("btn_edit"), url: "" },
    ];



    const validationSchema = Yup.object().shape({
        title: Yup.string().trim().required("Title is required"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: initialData,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            globalLoader(true);
            setSubmitted(true);

            const formData = new FormData();
            formData.append("id", id);
            formData.append("title", values.title);
            formData.append("status", values.status);


            Update(formData)
                .then((response) => {
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        setTimeout(() => {
                            navigate(`/admin/puja-type/list/1`);
                        }, 1000);
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        setSubmitted(false);
                    }
                })
                .catch((error) => {
                    console.log("error ====> ", error);
                    globalLoader(false);
                    setSubmitted(false);
                });
        },
    });



    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <h6 className="main-content-label mb-3">Edit Puja Type</h6>
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row row-sm">
                                {/* Title */}
                                <div className="col-lg-6 form-group">
                                    <label htmlFor="title" className="text-left d-flex">
                                        Title :<span className="requirestar">*</span>
                                    </label>
                                    <input
                                        name="title"
                                        id="title"
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter puja type title"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.title}
                                    />
                                    {formik.errors.title && formik.touched.title && (
                                        <span className="text-danger d-flex text-left">
                                            {formik.errors.title}
                                        </span>
                                    )}
                                </div>


                                {/* Status */}
                                <div className="col-lg-6 form-group">
                                    <label htmlFor="status" className="text-left d-flex">
                                        Status :
                                    </label>
                                    <select
                                        name="status"
                                        id="status"
                                        className="form-control"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.status}
                                    >
                                        <option value={1}>{t("Active")}</option>
                                        <option value={0}>{t("Inactive")}</option>
                                    </select>
                                </div>



                                <div className="col-md-12">
                                    <button
                                        className="btn btn-main-primary signbtn mr-2"
                                        type="submit"
                                        disabled={submitted}
                                    >
                                        <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                        {t("btn_update")}
                                    </button>
                                    <button
                                        className="btn ripple btn-secondary"
                                        type="button"
                                        onClick={() => navigate(-1)}
                                    >
                                        <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                        {t("btn_cancel")}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EditPujaType;
